import {
  BitkitTooltip,
  IconAbortCircleFilled,
  IconCheckCircle,
  IconCrossCircleFilled,
  IconSpinnerPurpleDouble,
} from '@bitrise/bitkit-v2';
import { ReactNode } from 'react';

import { BuildToolInvocationStatus } from '@/models/BuildToolInvocation';

type InvocationStatusIconProps = {
  status: BuildToolInvocationStatus;
  size?: '16' | '24';
};

// The desktop row renders this inside a LinkOverlay whose ::before covers the whole row at z-index 0,
// so the icon has to be lifted above it or the overlay swallows the hover that opens the tooltip.
const InvocationStatusIcon = ({ status, size }: InvocationStatusIconProps): ReactNode => {
  switch (status) {
    case BuildToolInvocationStatus.success:
      return (
        <BitkitTooltip text="Success" wrapTrigger>
          <IconCheckCircle color="icon/positive" size={size} position="relative" zIndex="1" />
        </BitkitTooltip>
      );
    case BuildToolInvocationStatus.failed:
      return (
        <BitkitTooltip text="Failed" wrapTrigger>
          <IconCrossCircleFilled color="icon/negative" size={size} position="relative" zIndex="1" />
        </BitkitTooltip>
      );
    case BuildToolInvocationStatus.timeout:
      return (
        <BitkitTooltip text="Aborted" wrapTrigger>
          <IconAbortCircleFilled color="icon/warning" size={size} position="relative" zIndex="1" />
        </BitkitTooltip>
      );
    case BuildToolInvocationStatus.pending:
    default:
      return (
        <BitkitTooltip text="In progress" wrapTrigger>
          <IconSpinnerPurpleDouble size={size} position="relative" zIndex="1" />
        </BitkitTooltip>
      );
  }
};

export default InvocationStatusIcon;
